import React from "react";
import ReactDOM from "react-dom";
import {SpeechProvider} from "@speechly/react-client"

import { Provider } from "./context/context";
import App from "./App";
import "./index.css";

ReactDOM.render(
  <SpeechProvider appId="b3ddba54-ce43-4c66-b116-c7d955695a58" language="en-US" >
  <Provider>
    <App />
  </Provider>
  </SpeechProvider>,
  document.getElementById("root")
);
